import {
  AddToBagLoading,
  AddToBagNavigationHeader,
  AddToBagPromptContainer,
  AddToBagUnavailableIngredients,
} from './components';

export const AddToBag = {
  NavigationHeader: AddToBagNavigationHeader,
  Loading: AddToBagLoading,
  PromptContainer: AddToBagPromptContainer,
  UnavailableIngredients: AddToBagUnavailableIngredients,
};
